import {SET_SELECTED_OFFER} from "./constants";
import {SetSelectedOfferActions, SetSelectedOfferState} from "./types";

const initialState: SetSelectedOfferState = {
  offer: undefined,
}

const reducer = (
  state = initialState,
  action: SetSelectedOfferActions,
): SetSelectedOfferState => {
  switch (action.type) {
    case SET_SELECTED_OFFER:
      return {
        offer: action.payload,
      };
    default:
      return state;
  }
}

export default reducer;
